import { ServiceTime, ServiceTimeKindType } from '@ancon/wildcat-types'

/**
 * Whether a scheduled service time has already passed. Core rejects checkout
 * updates carrying such a time (`ErrorCode.ServiceTimeInThePast`), so it must
 * not be written back into the checkout filters.
 */
export default function isServiceTimeInThePast(
  serviceTime?: ServiceTime | null,
  now: number = Date.now(),
) {
  if (
    serviceTime?.kind !== ServiceTimeKindType.AtSpecifiedTime ||
    !serviceTime.time
  ) {
    return false
  }

  const serviceTimeValue = new Date(serviceTime.time).valueOf()

  return !Number.isNaN(serviceTimeValue) && serviceTimeValue <= now
}
